export default (el, data) => {
	Object.keys(data).forEach(key => {
		el.setAttribute(`data-${key}`, data[key]);
	});
};
